import * as React from "react";
import MapBase from "./global/MapBase";

const MapPreview = ({
  lat = 0,
  lng = 0,
  zoom = 14,
}: {
  lat?: number;
  lng?: number;
  zoom?: number;
}) => {
  return (
    <MapBase
        center={{ lat, lng }}
        zoom={zoom}
      markers={[
        {
          id: "preview-marker",
          position: { lat, lng },
        },
      ]}
    />
  );
};
export default React.memo(MapPreview);
